import React from 'react';
import classNames from 'clsx';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {classes} from './BundledItems.st.css';
import {BundledItemModel} from '../../../../../../domain/models/LineItems/BundledItem.model';
import {CartItemThumbnail} from '../../../CartItemThumbnail/CartItemThumbnail';
import {ItemLink} from '../ItemLink/ItemLink';

export enum BundledItemsDataHook {
  Root = 'BundledItemsDataHook.Root',
  List = 'BundledItemsDataHook.List',
  Item = 'BundledItemsDataHook.Item',
  Title = 'BundledItemsDataHook.Title',
}

interface BundledItemsProps {
  bundledItems: BundledItemModel[];
  showThumbnailBySettings: boolean;
  thumbnailClassName?: string;
}

export const BundledItems = ({bundledItems, showThumbnailBySettings, thumbnailClassName}: BundledItemsProps) => {
  const {t} = useTranslation();

  return (
    <div className={classes.root} data-hook={BundledItemsDataHook.Root}>
      <ul className={classes.list} data-hook={BundledItemsDataHook.List}>
        {bundledItems.map((bundledItem) => (
          <li key={bundledItem.id} className={classes.item} data-hook={BundledItemsDataHook.Item}>
            {showThumbnailBySettings && (
              <CartItemThumbnail
                name={bundledItem.name}
                image={bundledItem.attributes.image}
                url={bundledItem.attributes.url}
                itemType={bundledItem.attributes.itemType}
                className={classNames(classes.thumbnail, thumbnailClassName)}
                isSubItem
              />
            )}
            <div className={classes.content}>
              <p className={classes.title} data-hook={BundledItemsDataHook.Title}>
                <ItemLink className={classes.titleLink} url={bundledItem.attributes.url}>
                  {t('cart.lineItems.bundle.itemTitle', {
                    quantity: bundledItem.quantity,
                    itemName: bundledItem.name,
                  })}
                </ItemLink>
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
